export default __webpack_public_path__ + "static/floating-light-e24b2890a771456c43b690dd1549f8ebfd8f102233717a1ace64eb2877a7681c.png";